var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAnnouncements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0969 2.62451L36.9624 5.48999L26.3206 16.1318L23.4551 13.2664L34.0969 2.62451Z",
    fill: "#62CE23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.327 7.07544H19.3794V11.1268H15.327V7.07544Z",
    fill: "#62CE23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8678 4.21094L23.7333 1.34546L26.598 4.2102L23.7326 7.07568L20.8678 4.21094Z",
    fill: "#62CE23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2245 12.0083L38.0899 14.8738L35.2252 17.7385L32.3597 14.873L35.2245 12.0083Z",
    fill: "#62CE23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0602 21.0259L37.0602 25.0783L27.659 25.0783L27.659 21.0259L37.0602 21.0259Z",
    fill: "#62CE23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2544 28.5243L4.47568 35.3948L11.3462 18.6161L21.2544 28.5243Z",
    stroke: "#0D1580",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9175 27.4833C23.8412 27.5595 23.2304 27.938 21.4922 27.3178C19.9125 26.7542 17.9796 25.5272 16.158 23.7056C14.3363 21.8839 13.1094 19.951 12.5457 18.3713C11.9256 16.6331 12.304 16.0223 12.3802 15.946C12.4565 15.8698 13.0673 15.4914 14.8055 16.1115C16.3852 16.6752 18.3181 17.9021 20.1398 19.7238C21.9614 21.5454 23.1884 23.4783 23.752 25.058C24.3722 26.7962 23.9937 27.407 23.9175 27.4833Z",
    fill: "#0D1580",
    stroke: "#0D1580",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnnouncements);
export default __webpack_public_path__ + "static/media/icon-announcements.c5702c1104a987706866f0573f4d1e13.svg";
export { ForwardRef as ReactComponent };